/* GLOBAL YOUTUBE INITIALIZATION QUEUE */
window._ytReadyQueue = window._ytReadyQueue || [];
window._ytApiReady = window._ytApiReady || false;

window.onYouTubeIframeAPIReady = function () {
    window._ytApiReady = true;

    // Flush queue exactly once
    window._ytReadyQueue.forEach((fn) => fn());
    window._ytReadyQueue.length = 0;
};

/* SAFE REGISTRATION FUNCTION */
function onYouTubeReady(fn) {
    if (window._ytApiReady || (window.YT && window.YT.Player)) {
        fn(); // If API is already ready then run immediately
    } else {
        window._ytReadyQueue.push(fn); // If API is not ready, queue it
    }
}

/* GLOBAL PLAYER REGISTRIES */
const desktopPlayers = {};
const desktopReady = {};

const mobilePlayers = {};
const mobileReady = {};

/* STOP HELPERS */
function safeStopDesktop(index) {
    const p = desktopPlayers[index];
    if (desktopReady[index] && p && typeof p.stopVideo === "function") {
        p.stopVideo();
    }
}

function safeStopMobile(id) {
    const p = mobilePlayers[id];
    if (mobileReady[id] && p && typeof p.stopVideo === "function") {
        p.stopVideo();
    }
}

/* DESKTOP PLAYER INITIALIZATION */
function initDesktopYouTubePlayers() {
    const ids = ["yt-one", "yt-two", "yt-three", "yt-four"];

    ids.forEach((id, index) => {
        desktopPlayers[index] = new YT.Player(id, {
            events: {
                onReady: () => {
                    desktopReady[index] = true;
                },
            },
        });
    });
}

/* MOBILE PLAYER INITIALIZATION */
function initMobileYouTubePlayers() {
    const iframes = document.querySelectorAll("iframe[id$='-m']");

    iframes.forEach((iframe) => {
        const id = iframe.id;

        mobilePlayers[id] = new YT.Player(id, {
            events: {
                onReady: () => {
                    mobileReady[id] = true;
                },
            },
        });
    });
}

/* DESKTOP TABS */
function initDesktopTabs() {
    const root = document.querySelector(".tabbed-section");
    if (!root) return;

    const tabData = JSON.parse(root.dataset.tabData);

    const buttons = root.querySelectorAll(".card-selector");
    const videos = [
        root.querySelector("#video-one"),
        root.querySelector("#video-two"),
        root.querySelector("#video-three"),
        root.querySelector("#video-four"),
    ];

    const descriptionEl = root.querySelector(".card-left p");

    let currentIndex = 0;

    buttons.forEach((btn, index) => {
        btn.addEventListener("click", () => {
            buttons.forEach((b) => b.classList.remove("selected"));
            btn.classList.add("selected");

            safeStopDesktop(currentIndex);

            videos.forEach((v) => (v.style.display = "none"));
            videos[index].style.display = "flex";

            descriptionEl.textContent = tabData[index].description;

            currentIndex = index;
        });
    });
}

/* MOBILE ACCORDION */
function initMobileAccordion() {
    const root = document.querySelector(".tabbed-section-mobile");
    if (!root) return;

    const triggers = root.querySelectorAll(".tabbed-section-accordiontrigger");
    const panels = root.querySelectorAll(".tabbed-section-accordionpanel");

    triggers.forEach((trigger) => {
        trigger.addEventListener("click", () => {
            const item = trigger.closest(".tabbed-section-accordionitem");
            const targetId = trigger.dataset.target;
            const panel = root.querySelector(`#${targetId}`);

            panels.forEach((p) => {
                if (p !== panel) {
                    p.classList.remove("open");
                    p.style.maxHeight = null;

                    const otherItem = p.closest(".tabbed-section-accordionitem");
                    if (otherItem) otherItem.classList.remove("opened");

                    const iframe = p.querySelector("iframe");
                    if (iframe) safeStopMobile(iframe.id);
                }
            });

            const isOpen = panel.classList.contains("open");

            if (isOpen) {
                panel.classList.remove("open");
                panel.style.maxHeight = null;
                item.classList.remove("opened");

                const iframe = panel.querySelector("iframe");
                if (iframe) safeStopMobile(iframe.id);
            } else {
                panel.classList.add("open");
                panel.style.maxHeight = panel.scrollHeight + "px";
                item.classList.add("opened");

                const onDone = () => {
                    panel.removeEventListener("transitionend", onDone);

                    const offset = 80;
                    const top = item.getBoundingClientRect().top + window.scrollY - offset;

                    window.scrollTo({
                        top,
                        behavior: "smooth",
                    });
                };

                panel.addEventListener("transitionend", onDone);
            }
        });
    });

    window.addEventListener("resize", () => {
        panels.forEach((panel) => {
            panel.classList.remove("open");
            panel.style.maxHeight = null;

            const item = panel.closest(".tabbed-section-accordionitem");
            if (item) item.classList.remove("opened");

            const iframe = panel.querySelector("iframe");
            if (iframe) safeStopMobile(iframe.id);
        });
    });
}

/* EXPORT INITIALIZER */
export function initTabbedComponent() {
    initDesktopTabs();
    initMobileAccordion();
}

/* REGISTER YOUTUBE INITIALIZERS */
onYouTubeReady(initDesktopYouTubePlayers);
onYouTubeReady(initMobileYouTubePlayers);
